<template>

  <div>

    <div v-bind:style="{padding: '8px', background: survey.colors.accent_color, color: survey.colors.accent_color2, 'margin-bottom': '25px'}">
      {{ $tc("message.board", 1) }} <b>{{ survey.name }}</b>
    </div>

    <div v-for="question in survey.data" class="hit-form-group hit-text-center" >

      <b v-bind:style="{color: survey.colors.text_color}">{{ question[0] }}</b>

      <div>

        <div class="hit-form-group">
          <a href="#" v-on:click.prevent="">
            <hit_stars v-bind:style="{color: survey.colors.accent_color}"  class="hit-html-h1" :stars="save_data.stars[question[0]]" :click="function(vote){ set_answer(vote, question[0]) }" />
          </a>
        </div>

        <div class="hit-col-md-12" v-if="save_data.stars[question[0]]">
          <div class="hit-form-group">
            <label :for="question[0]" v-bind:style="{color: survey.colors.text_color}">{{ $t('message.whyXStars', {stars: save_data.stars[question[0]]})+' ('+$t('message.optional')+')' }}</label>
            <input
            :id="question[0]"
            v-bind:style="{color: survey.colors.accent_color, 'border-color': survey.colors.accent_color, 'background-color': survey.colors.background_color}"
            v-model="save_data.comments[question[0]]"
            type="text"
            class="hit-form-control"
            v-bind:placeholder="$t('message.whyXStars', {stars: save_data.stars[question[0]]})" />
        </div>
        </div>
        <div class="hit-clearfix" />
      </div>

      <hr v-bind:style="{'border-color': survey.colors.accent_color}" v-if="question != Object.values(survey.data)[  Object.keys(survey.data).length -1 ]">

    </div>

    <transition name="slideDown">
      <a href="#" v-if="!error" class="hit-btn hit-btn-default hit-btn-block" v-bind:style="{'background-color': survey.colors.accent_color, color: survey.colors.accent_color2}" v-on:click.prevent="function(){ callback(save_data) }">{{ $tc("message.save", 1) }}</a>
    </transition>

  </div>

</template>

<script>

export default{

  props: {survey: Object, callback: Function, save: Object},

  data: function () {
    var save_data

    if (Object.keys(this.save).length) { save_data = this.save } else { save_data = this.get_empty_save() }

    return {
      save_data: save_data,
      error: true
    }
  },

  methods: {

    get_empty_save: function () {
      var save_data = {stars: {}, comments: {}}

      this.survey.data.forEach(function (question, index) {
        save_data.stars[question[0]] = 0
        save_data.comments[question[0]] = ''
      })

      return save_data
    },

    check_error(){

      this.error = false

      Object.values(this.save_data.stars).forEach(function (data) {
        if (data === 0) {
          this.error = true
          return false
        }
      }.bind(this));



    },

    set_answer: function (vote, question) {
      this.save_data.stars[question] = vote

      this.check_error();


    }

  },

  mounted(){

    this.check_error();

  }

}

</script>
